
export class ModuleType {
    static organisationDashboard = 0;
    static onBoarding = 1;
    static licence = 2;
    // static audit = 3;
    static userProfile = 3;
    static organisationProfile = 4;
    static maRepresentative = 5
    // static invited = 3;
    // static created = 4;

}